import { downloadPdfDocument } from "./PDFHelper/PDFRenderer";
import JSZip from "jszip";
import { REQUEST_URL } from "./Config";
import mime from "mime";
import ImageScaleType from "./image_converter/ImageScaleType";
import ImageDrawMode from "./image_converter/ImageDrawMode";
import { getPositionCoordinates } from "./PDFHelper/PDFRenderer";

//dpi scale
//scale and descale canvas with this factor
export const desiredDPI = 200;
const defaultPDFDPI = 72;
const scaleDPI = desiredDPI / defaultPDFDPI;

//generate random string
//of length
export const generateRandomString = (length) => {
  //chearcters
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  //init
  let result = "";
  //loop
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  //return
  return result;
};

//check if valid email addess
export function isValidEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //return
  return emailRegex.test(email);
}

//is valid phone number
export function isValidPhoneNumber(number) {
  // A simple regex for 10-digit numbers (customize as needed)
  const regex = /^\d{10}$/;
  return regex.test(number);
}

//is valid name
export function isValidName(name) {
  const nameRegex = /^[a-zA-Z\s]+$/; // Allows letters and spaces
  return nameRegex.test(name);
}

//is valid url string
export function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
}

//file size string from bytes
export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

//get file extension from file name
export function getFileExtension(fileName) {
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex !== -1 && lastDotIndex < fileName.length - 1) {
    return fileName.substring(lastDotIndex + 1);
  }
  return ""; // No extension found or invalid format
}

//initialize
var pdfjsLib = window["pdfjs-dist/build/pdf"];
pdfjsLib.GlobalWorkerOptions.workerSrc = "./js/pdf.worker.js";

//load encrypted pdf bytes
//extract pages as image
//create new pdf file
//return bytes as arraybuffer
export async function readEncryptedPDFFileAsArrayBuffer(
  file,
  password,
  callback,
) {
  //return
  return new Promise(async (resolve, reject) => {
    //try catch
    try {
      //read pdf file
      const data = await readPDFFile(file);
      //page images
      //extract pages as image
      const [images, dimension] = await renderPDFPages(
        data,
        password,
        "image/jpeg",
        1.0,
        false,
        false,
        [], //render all pages
        (perct) => {
          //return percentage
          callback(perct);
        },
      );
      // generate new pdf
      // with compressed images
      //remove password
      await createPDFDocumentUsingImages(
        "temp_pdf",
        images,
        dimension,
        "",
        (blob) => {
          //return blob as arraybuffer
          resolve(blob.arrayBuffer());
        },
      );
    } catch (e) {
      //reject
      resolve(null);
    }
  });
}

//is pdf encrypted
export async function isPdfFilePasswordCorrect(file, password) {
  try {
    //read pdf file
    const data = await readPDFFile(file);
    //load pdf document
    await pdfjsLib.getDocument({
      data,
      password: password,
    }).promise;
    //return
    return true;
  } catch (e) {
    console.log("Message: ", e);
    //return
    return false;
  }
}

//render pdf page
//render pdf page as image
//scale page before rendering 0 - 1
//render single page
export async function renderPDFPage(
  data,
  password,
  mimetype,
  scale,
  page_index,
) {
  //dimension
  let dimension = [0, 0];

  //try - catch
  try {
    //load pdf document
    const pdf = await pdfjsLib.getDocument({
      data,
      password: password,
    }).promise;

    //check page count
    if (pdf.numPages > page_index) {
      //canvas
      const canvas = document.createElement("canvas");
      canvas.setAttribute("className", "canv");

      //render first page as thumbnail
      var page = await pdf.getPage(page_index + 1);
      //check
      //set dimension
      if (dimension[0] === 0 && dimension[1] === 0) {
        //set dimension
        dimension = await getPDFPageDimension(page);
      }

      //viewport
      var viewport = page.getViewport({
        scale: scale * scaleDPI,
      });
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      //render
      var render_context = {
        canvasContext: canvas.getContext("2d"),
        viewport: viewport,
      };
      //render
      await page.render(render_context).promise;
      //image
      let img = canvas.toDataURL(mimetype);

      //await storeBlob(img, i);
      //cleanup
      page.cleanup();
      //release canvas
      releaseCanvas(canvas);
      //destroy document
      pdf.cleanup();
      pdf.destroy();
      //return
      return [img, pdf.numPages, dimension];
    } else {
      //destroy document
      pdf.cleanup();
      pdf.destroy();
      //return
      return [null, 0, dimension];
    }
  } catch (e) {
    console.log("Error: ", e);
    //throw error
    throw e;
  }
}

//render pdf pages
//render pdf pages as image
//scale page before rendering 0 - 1 scales resolution
//render all pages
export async function renderPDFPages(
  data,
  password,
  mimetype,
  scale,
  scaleResolution,
  grayscale,
  indices, //page indexes to render, if empty render all
  callback,
) {
  //page images
  let renderedPDFPage = [];
  //dimension
  let dimension = [0, 0];

  //try - catch
  try {
    //load pdf document
    const pdf = await pdfjsLib.getDocument({
      data,
      password: password,
    }).promise;

    //loop
    for (let i = 0; i < pdf.numPages; i++) {
      //check
      //if indices isset and indices not contains page number
      //skip rendering
      if (indices.length > 0) {
        //check
        if (indices.includes(Number(i)) === false) {
          //continue
          continue;
        }
      }

      //canvas
      const canvas = document.createElement("canvas");
      canvas.setAttribute("className", "canv");

      //render first page as thumbnail
      var page = await pdf.getPage(i + 1);
      //check
      //set dimension
      if (dimension[0] === 0 && dimension[1] === 0) {
        //set dimension
        dimension = await getPDFPageDimension(page);
      }

      //viewport
      var viewport = page.getViewport({
        scale: (scaleResolution ? scale : 1.0) * scaleDPI,
      });
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      //render
      var render_context = {
        canvasContext: canvas.getContext("2d"),
        viewport: viewport,
      };

      //check
      if (grayscale === true) {
        //grayscale
        // Apply grayscale filter to the context
        render_context.canvasContext.filter = "grayscale(100%)"; // or 'grayscale(1)'
      }

      //render
      await page.render(render_context).promise;
      //image
      let img = await canvasToBlob(canvas, scale, mimetype);
      //add to array
      renderedPDFPage = [...renderedPDFPage, img];
      //callback
      callback((i + 1) / pdf.numPages, img, i);

      //cleanup
      page.cleanup();
      //release canvas
      releaseCanvas(canvas);
    }
    //destroy document
    pdf.cleanup();
    pdf.destroy();
    //return
    return [renderedPDFPage, dimension];
  } catch (e) {
    //return
    console.log("Error: ", e);
    throw e;
  }
}

//get pdf dimension
function getPDFPageDimension(page) {
  //viewport
  const viewport = page.getViewport({ scale: 1 });

  // The width and height are in pixels
  const widthInPixels = viewport.width;
  const heightInPixels = viewport.height;
  //return
  return [Math.floor(widthInPixels), Math.floor(heightInPixels)];
}

//draw image on canvas
//get as jpg
export async function convertImageToMimeType(file, mimetype, scale) {
  //return
  return new Promise((resolve, reject) => {
    //canvas
    const canvas = document.createElement("canvas");
    canvas.setAttribute("className", "canv");
    //context
    const ctx = canvas.getContext("2d");
    const image = new Image(); // Create a new Image object

    // Set crossOrigin to "Anonymous" if loading images from different domains
    // to avoid potential CORS issues that restrict canvas data access.
    image.crossOrigin = "Anonymous";
    image.src = URL.createObjectURL(file);

    image.onload = async () => {
      // Set canvas dimensions to match the image
      canvas.width = image.width;
      canvas.height = image.height;

      // Draw the image onto the canvas once it's loaded
      ctx.drawImage(image, 0, 0, image.width, image.height);
      //save canvas
      //image
      let img = await canvasToBlob(canvas, scale, mimetype);
      //resolve
      resolve(img);
      //release canvas
      releaseCanvas(canvas);
    };

    // Optional: Handle errors during image loading
    image.onerror = (err) => {
      console.error("Error loading image:", err);
      //release canvas
      releaseCanvas(canvas);
      //reject
      reject(null);
    };
  });
}

//convert image
//set type
//draw mode
//quality (0 - 1)
//scale (0 - 1)
//settings = {mimetype:, quality:, scaleType:, grayscale:, scale:, width:, height:, drawMode:}
export async function convertImage(file, outputSettings) {
  //return
  return new Promise((resolve, reject) => {
    //canvas
    const canvas = document.createElement("canvas");
    canvas.setAttribute("className", "canv");
    //context
    const ctx = canvas.getContext("2d");

    const image = new Image(); // Create a new Image object

    // Set crossOrigin to "Anonymous" if loading images from different domains
    // to avoid potential CORS issues that restrict canvas data access.
    image.crossOrigin = "Anonymous";
    image.src = URL.createObjectURL(file);

    image.onload = async () => {
      //output type
      const mimetype = outputSettings.mimetype;
      //quality
      const quality = outputSettings.quality;
      //scale type
      const scaleType = outputSettings.scaleType;
      //scale
      const scale = outputSettings.scale;
      //width
      const width =
        outputSettings.scaleType === ImageScaleType.NONE
          ? image.width
          : outputSettings.scaleType === ImageScaleType.SCALE
            ? image.width * scale
            : outputSettings.width;
      //width
      const height =
        outputSettings.scaleType === ImageScaleType.NONE
          ? image.height
          : outputSettings.scaleType === ImageScaleType.SCALE
            ? image.height * scale
            : outputSettings.height;
      //draw mode
      const drawMode = outputSettings.drawMode;

      // Set canvas dimensions to match the image
      canvas.width = width;
      canvas.height = height;

      //grayscale
      //check
      if (outputSettings.grayscale) {
        //set grayscale filter
        ctx.filter = "grayscale(100%)";
      }

      //output rect
      let outputRect = [0, 0, width, height];
      //set rect w.r.t drawmode
      //if scale type is FIXED
      if (scaleType === ImageScaleType.FIXED) {
        //check
        if (drawMode === ImageDrawMode.ASPECT_FILL) {
          //rect
          outputRect = aspectFillRect(
            [0, 0, width, height],
            [0, 0, image.width, image.height],
          );
        } else if (drawMode === ImageDrawMode.ASPECT_FIT) {
          //rect
          outputRect = aspectFitRect(
            [0, 0, width, height],
            [0, 0, image.width, image.height],
          );
        } else if (drawMode === ImageDrawMode.SCAlE_TO_FILL) {
          //set
          outputRect = [0, 0, width, height];
        }
      }

      // Draw the image onto the canvas once it's loaded
      ctx.drawImage(
        image,
        outputRect[0],
        outputRect[1],
        outputRect[2],
        outputRect[3],
      );
      //save canvas
      //image
      let img = await canvasToBlob(canvas, quality, mimetype);
      //resolve
      resolve(img);
      //release canvas
      releaseCanvas(canvas);
    };

    // Optional: Handle errors during image loading
    image.onerror = (err) => {
      console.error("Error loading image:", err);
      //release canvas
      releaseCanvas(canvas);
      //reject
      reject(null);
    };
  });
}

//convert image
//set type
//draw mode
//quality (0 - 1)
//scale (0 - 1)
//settings = {mimetype:, quality:, scaleType:, grayscale:, scale:, width:, height:, drawMode:}
//release canvas after use
//as canvas is not released
export async function convertImageObject(image, outputSettings) {
  //return
  return new Promise(async (resolve, reject) => {
    //canvas
    const canvas = document.createElement("canvas");
    canvas.setAttribute("className", "canv");
    //context
    const ctx = canvas.getContext("2d");

    //scale type
    const scaleType = outputSettings.scaleType;
    //scale
    const scale = outputSettings.scale;
    //width
    const width =
      outputSettings.scaleType === ImageScaleType.NONE
        ? image.width
        : outputSettings.scaleType === ImageScaleType.SCALE
          ? image.width * scale
          : outputSettings.width;
    //width
    const height =
      outputSettings.scaleType === ImageScaleType.NONE
        ? image.height
        : outputSettings.scaleType === ImageScaleType.SCALE
          ? image.height * scale
          : outputSettings.height;
    //draw mode
    const drawMode = outputSettings.drawMode;

    // Set canvas dimensions to match the image
    canvas.width = width;
    canvas.height = height;

    //grayscale
    //check
    if (outputSettings.grayscale) {
      //set grayscale filter
      ctx.filter = "grayscale(100%)";
    }

    //output rect
    let outputRect = [0, 0, width, height];
    //set rect w.r.t drawmode
    //if scale type is FIXED
    if (scaleType === ImageScaleType.FIXED) {
      //check
      if (drawMode === ImageDrawMode.ASPECT_FILL) {
        //rect
        outputRect = aspectFillRect(
          [0, 0, width, height],
          [0, 0, image.width, image.height],
        );
      } else if (drawMode === ImageDrawMode.ASPECT_FIT) {
        //rect
        outputRect = aspectFitRect(
          [0, 0, width, height],
          [0, 0, image.width, image.height],
        );
      } else if (drawMode === ImageDrawMode.SCAlE_TO_FILL) {
        //set
        outputRect = [0, 0, width, height];
      }
    }

    // Draw the image onto the canvas once it's loaded
    ctx.drawImage(
      image,
      outputRect[0],
      outputRect[1],
      outputRect[2],
      outputRect[3],
    );
    //resolve
    resolve(canvas);
  });
}

//read pdf file as arraybuffer
export async function readPDFFileAsArrayBuffer(file) {
  //promise
  return new Promise((resolve, reject) => {
    //fetch url
    fetch(URL.createObjectURL(file))
      .then((res) => {
        //resolve
        resolve(res.arrayBuffer());
      })
      .catch((e) => {
        reject(e);
      });
  });
}

//read file
//output blob
export async function readFile(file) {
  //promise
  return new Promise((resolve, reject) => {
    //fetch url
    fetch(URL.createObjectURL(file))
      .then((response) => {
        response
          .blob()
          .then((blob) => {
            //read pdf file
            resolve(blob);
          })
          .catch((e) => {
            reject(e);
          });
      })
      .catch((e) => {
        reject(e);
      });
  });
}

//read pdf file
//as blob
export async function readPDFFile(file) {
  //promise
  return new Promise((resolve, reject) => {
    //fetch url
    fetch(URL.createObjectURL(file))
      .then((response) => {
        response
          .blob()
          .then((blob) => {
            let reader = new FileReader();
            reader.onload = (e) => {
              //convert base 64
              const data = window.atob(
                e.target.result.replace(/.*base64,/, ""),
              );
              //resolve
              resolve(data);
            };
            //read pdf file
            reader.readAsDataURL(blob);
          })
          .catch((e) => {
            reject(e);
          });
      })
      .catch((e) => {
        reject(e);
      });
  });
}

//save blob file
export const saveFile = async (blob, filename) => {
  return new Promise((resolve, reject) => {
    try {
      const a = document.createElement("a");
      a.download = filename;
      a.href = URL.createObjectURL(blob);
      a.addEventListener("click", (e) => {
        setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
      });
      a.click();
      //return
      resolve(true);
    } catch {
      //return
      resolve(false);
    }
  });
};

//mime type from base64 string
export function mimeTypeFromBase64(base64string) {
  //regex
  const match = base64string.match(/^data:(.*);base64,/);
  //check
  if (match && match.length > 1) {
    //mimetype
    const mimeType = match[1]; // Output: "application/pdf"
    //return
    return mimeType;
  }
  //retunr
  return null;
}

//canvas to blob
export async function canvasToBlob(canvas, quality, mimetype) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        //url
        //return
        resolve(blob);
      },
      mimetype === "image/jpg" ? "image/jpeg" : mimetype, //as "image/jpg" will return "image/png" as it is not supported
      quality,
    );
  });
}

//file to base64
export async function fileToBase64(file) {
  //return
  return new Promise((resolve, reject) => {
    try {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    } catch {
      //return
      resolve(null);
    }
  });
}

//blob to base64
export function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

/**
 * Converts a Blob object to a File object.
 * @param {Blob} theBlob - The Blob object to convert.
 * @param {string} fileName - The desired name for the new File object.
 * @returns {File} The new File object.
 */
export function blobToFile(blob, fileName) {
  return new File([blob], fileName, {
    lastModified: new Date().getTime(),
    type: blob.type,
  });
}

//release canvas
//clean up memory
export const releaseCanvas = (canvas) => {
  canvas.width = 1;
  canvas.height = 1;
  const ctx = canvas.getContext("2d");
  ctx && ctx.clearRect(0, 0, 1, 1);
};

//create pdf document with images
//images as
export async function createPDFDocumentUsingImages(
  title,
  images,
  dimension,
  password,
  callback,
) {
  //page size
  let width = dimension[0];
  let height = dimension[1];

  //download pdf
  downloadPdfDocument(title, width, height, password, images, async (blob) => {
    //callback
    callback(blob);
  });
}

//check if string isnumber
export function isNumeric(value) {
  return /^-?\d+$/.test(value);
}

//zip multiple files
//files as blob
export async function downloadMultipleFiles(files, filename, compressionType) {
  //return promise
  return new Promise(async (resolve, reject) => {
    //zip
    const zip = new JSZip();
    //map
    for (var i = 0; i < files.length; i++) {
      //extension
      const fileExt = getExtensionFromMimeType(files[i].type);
      // Add the file to the zip archive with its desired filename
      zip.file(
        files[i] instanceof File
          ? files[i].path
          : `${filename}_${i}.${fileExt === null ? "" : fileExt}`,
        files[i],
      );
    }

    // Generate the zip file content
    await zip
      .generateAsync({
        type: "blob",
        compression: compressionType, //DEFLATE = Compression, STORE = no compression
        compressionOptions: {
          level: 9,
        },
      })
      .then((content) => {
        //return
        resolve(content);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // Handle errors as needed
        reject(error);
      });
  });
}

//get image dimension
//with data:image/jpeg,/yscxx format
export async function imageDimensionBase64(base64String) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64String;
    img.onload = () => {
      //resolve
      resolve([img.width, img.height]);
    };
  });
}

//get image dimension
export async function imageDimension(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      //resolve
      resolve([img.width, img.height]);
    };
  });
}

//get aspect fit rect
//index0=x
//index1=y
//index2=width
//index3=height
//parentRect = rect where e want to fit child rect
//childRect = rect of the child object
export function aspectFitRect(parentRect, childRect) {
  //width ratio
  const widthR = parentRect[2] / childRect[2];
  const heightR = parentRect[3] / childRect[3];
  //check
  const scale = widthR < heightR ? widthR : heightR;
  //new width
  const width = childRect[2] * scale;
  //new height
  const height = childRect[3] * scale;
  //originx
  const x = parentRect[0] + (parentRect[2] - width) * 0.5;
  //originy
  const y = parentRect[1] + (parentRect[3] - height) * 0.5;
  //return
  return [x, y, width, height];
}

//get aspect fill rect
//index0=x
//index1=y
//index2=width
//index3=height
//parentRect = rect where e want to fit child rect
//childRect = rect of the child object
export function aspectFillRect(parentRect, childRect) {
  //width ratio
  const widthR = parentRect[2] / childRect[2];
  const heightR = parentRect[3] / childRect[3];
  //check
  const scale = widthR > heightR ? widthR : heightR;
  //new width
  const width = childRect[2] * scale;
  //new height
  const height = childRect[3] * scale;
  //originx
  const x = parentRect[0] + (parentRect[2] - width) * 0.5;
  //originy
  const y = parentRect[1] + (parentRect[3] - height) * 0.5;
  //return
  return [x, y, width, height];
}

//color hex to rgb
export const hexToRgb = (hex) => {
  // Remove the '#' symbol if present
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16) / 255,
        g: parseInt(result[2], 16) / 255,
        b: parseInt(result[3], 16) / 255,
      }
    : { r: 0, g: 0, b: 0 };
};

//get all methods
//of a class
export function getAllMethods(object) {
  return Object.getOwnPropertyNames(object);
}

//check if valid date
export const isValidDateFormat = (dateString) => {
  // Attempt to create a Date object from the string
  const date = new Date(dateString);

  // Check if the date object is valid using isNaN()
  // Valid dates return a number, invalid dates return NaN (Not a Number)
  // We also check if the input is a Date object instance
  return date instanceof Date && !isNaN(date);
};

//fetch web page content as html
export async function fetchWebPageContentasHTML(webURL) {
  //get the access token from local storage
  var accessToken = localStorage.getItem("access_token");
  accessToken =
    accessToken !== null && accessToken !== "undefined" ? accessToken : "";

  //retunr
  return new Promise(async (resolve, reject) => {
    //fetch
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "GET_WEBPAGE_CONTENT",
        web_page_url: webURL,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //check success
        if (data.success === true) {
          //return
          resolve(data.web_content);
        } else {
          //return
          resolve("");
        }

        console.log("Response: ", data);
      })
      .catch((e) => {
        console.error("Error: ", e);
        //retunr
        resolve("");
      });
  });
}

//read html file as text
export const readHTMLFileAsText = async (file) => {
  //retun
  return new Promise((resolve, reject) => {
    //file reader
    const reader = new FileReader();

    // This function runs when the file reading is complete
    reader.onload = (e) => {
      const text = e.target.result;
      //return
      resolve(text);
    };

    // This function runs if an error occurs during reading
    reader.onerror = (e) => {
      //return
      resolve("");
    };

    // Read the file content as a text string
    reader.readAsText(file);
  });
};

//add custom script to html code
//scriptSrc = custom script url
//htmlCode = raw html code
export function addCustomScriptToHTMLCode(htmlCode, scriptSrc, callback) {
  //get dom element
  const domElement = new DOMParser().parseFromString(htmlCode, "text/html");

  //Create a new, active script element in the current document
  const activeScript = document.createElement("script");

  // 4. Set the source attribute
  activeScript.src = scriptSrc;
  activeScript.id = "html-to-image";
  activeScript.type = "text/javascript"; // Optional, but good practice

  // 5. Append the active script to the actual <head> to execute it
  domElement.head.appendChild(activeScript);

  //xml serializer
  const serializer = new XMLSerializer();
  const xmlString = serializer.serializeToString(domElement);

  //create html file
  //Create a Blob object from the HTML string
  // Specify the MIME type as 'text/html'
  const blob = new Blob([xmlString], { type: "text/html" });
  //Create a URL for the Blob object
  const url = URL.createObjectURL(blob);
  //callback
  callback(url);
}

//get image file dimensiojn
export const getImageDimensionsFromBlob = (blob) => {
  //return
  return new Promise((resolve, reject) => {
    //Create a new Image object
    const img = new Image();
    //Set the image source to the object URL to trigger loading
    img.src = URL.createObjectURL(blob);

    //Set the onload event handler to capture dimensions
    img.onload = () => {
      //resolve
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };

    //on error
    img.onerror = () => {
      //resolve
      resolve({ width: 1, height: 1 });
    };
  });
};

//create array from start inde to end index
//start and end index is inclusive
export const createArrayInRange = (start, end) => {
  const length = end - start + 1;
  return Array.from({ length }, (_, index) => start + index);
};

//stitch multple images to single image
//output image maximum height
export async function stitchMultipleImagesToSingleImage(
  images,
  mimetype,
  maxImageHeight,
  maxImageWidth,
) {
  //return
  return new Promise(async (resolve, reject) => {
    //input images total height
    let inputImagesTotalHeight = 0;
    //loop
    for (let i = 0; i < images.length; i++) {
      //image dimension
      const imgDimen = await getImageDimensionsFromBlob(images[i]);
      //add
      inputImagesTotalHeight = inputImagesTotalHeight + imgDimen.height;
    }

    //image max width
    let imagesMaxWidth = 0;
    //loop
    for (let i = 0; i < images.length; i++) {
      //image dimension
      const imgDimen = await getImageDimensionsFromBlob(images[i]);
      //add
      imagesMaxWidth =
        imagesMaxWidth < imgDimen.width ? imgDimen.width : imagesMaxWidth;
    }

    //output width
    const outputImageWidth = Math.min(maxImageWidth, imagesMaxWidth);
    //output height
    const outputImageHeight = Math.min(maxImageHeight, inputImagesTotalHeight);

    console.log("Output: ", outputImageWidth, outputImageHeight);

    //image block height
    //-1 = take image original height
    //else divide maxheight with number of images
    const imgBlockheight = outputImageHeight / images.length;
    const imgBlockWidth = outputImageWidth;

    console.log("Output Block: ", imgBlockWidth, imgBlockheight);

    //canvas
    const canvas = document.createElement("canvas");
    canvas.setAttribute("className", "canv");
    //context
    const ctx = canvas.getContext("2d");
    canvas.height = outputImageHeight;
    canvas.width = outputImageWidth;

    //loop through images array
    for (let i = 0; i < images.length; i++) {
      //solve first
      //wait till onload return
      await new Promise((resolve, reject) => {
        // Create a new Image object
        const image = new Image();
        // Set crossOrigin to "Anonymous" if loading images from different domains
        // to avoid potential CORS issues that restrict canvas data access.
        image.crossOrigin = "Anonymous";
        image.src = URL.createObjectURL(images[i]);
        image.onload = async () => {
          //image rect
          const imgRect = aspectFitRect(
            [0, i * imgBlockheight, imgBlockWidth, imgBlockheight],
            [0, i * imgBlockheight, image.width, image.height],
          );
          // Draw the image onto the canvas once it's loaded
          ctx.drawImage(image, imgRect[0], imgRect[1], imgRect[2], imgRect[3]);
          //return
          resolve();
        };

        //on error
        image.onerror = () => {
          //return
          resolve();
        };
      });
    }

    //save canvas
    //image
    let img = await canvasToBlob(canvas, 1.0, mimetype);
    //resolve
    resolve(img);
    //release canvas
    releaseCanvas(canvas);
  });
}

//get extension from mime type
export const getExtensionFromMimeType = (mimeType) => {
  // mime.getExtension() returns the extension string or null if not found
  const extension = mime.getExtension(mimeType);
  return extension ? `${extension}` : null;
};

//draw text on canvas with configurations
export async function drawTextOnCanvas(canvas, configurations) {
  // Get the 2D drawing context
  const ctx = canvas.getContext("2d");
  // Set global alpha for subsequent drawings
  // 0 - 1
  ctx.globalAlpha = configurations.opacity / 100;
  //set text baseline
  ctx.textBaseline = "top";

  //check text
  if (configurations.text !== "") {
    //Set the font style and size
    ctx.font = `${configurations.font_size}px ${configurations.font}`;
    //Sets the color
    ctx.fillStyle = configurations.color;
    //get text width height
    const metrics = ctx.measureText(configurations.text);
    //width
    const textWidth = metrics.width;
    // Modern browsers offer more detailed metrics for height
    // Fallback to approximate height based on font size if necessary
    const textHeight =
      metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent ||
      parseInt(ctx.font, 10) ||
      0;
    //place text
    //position
    const position = getPositionCoordinates(
      configurations.position,
      { width: canvas.width, height: canvas.height },
      textWidth,
      textHeight,
      configurations.padding,
    );

    //shift origin to top left
    //as our getPositionCoordinates will return coordinates w.r.t bottom left corner
    //+ve x right, +ve y. down
    const originX = position[0];
    const originY = -(position[1] + textHeight);

    //Save the current canvas state
    ctx.save();

    //move canvas origin to bottom left
    ctx.translate(0, canvas.height);
    //translate canvas origin to text center before rotate
    ctx.translate(originX + textWidth * 0.5, originY + textHeight * 0.5);

    // Rotate the canvas context by 45 degrees (converted to radians)
    var angleInRadians = (configurations.rotation * Math.PI) / 180;
    //rotate
    ctx.rotate(angleInRadians);

    //translate origin back to bottom left
    ctx.translate(-(originX + textWidth * 0.5), -(originY + textHeight * 0.5));

    //Set the desired blend mode
    ctx.globalCompositeOperation = configurations.on_top
      ? "source-over"
      : "destination-out";

    //fill text
    ctx.fillText(configurations.text, originX, originY);

    //Reset to default (good practice)
    ctx.globalCompositeOperation = "source-over";

    //Restore the canvas to its original state
    ctx.restore();

    //return canvas
    return canvas;
  } else {
    //return
    return canvas;
  }
}

//draw image on canvas with configurations
export async function drawImageOnCanvas(canvas, configurations) {
  //promise
  //return
  return new Promise((resolve, reject) => {
    // Get the 2D drawing context
    const ctx = canvas.getContext("2d");
    // Set global alpha for subsequent drawings
    // 0 - 1
    ctx.globalAlpha = configurations.opacity / 100;

    //check text
    if (configurations.image !== null) {
      //load image
      //check
      //create new image object
      const image = new Image(); // Create a new Image object

      // Set crossOrigin to "Anonymous" if loading images from different domains
      // to avoid potential CORS issues that restrict canvas data access.
      image.crossOrigin = "Anonymous";
      image.src = URL.createObjectURL(configurations.image);

      image.onload = async () => {
        //place text
        //position
        const position = getPositionCoordinates(
          configurations.position,
          { width: canvas.width, height: canvas.height },
          image.width,
          image.height,
          configurations.padding,
        );

        //shift origin to top left
        //as our getPositionCoordinates will return coordinates w.r.t bottom left corner
        //+ve x right, +ve y. down
        const originX = position[0];
        const originY = -(position[1] + image.height);

        //Save the current canvas state
        ctx.save();

        //move canvas origin to bottom left
        ctx.translate(0, canvas.height);
        //translate canvas origin to text center before rotate
        ctx.translate(
          originX + image.width * 0.5,
          originY + image.height * 0.5,
        );

        // Rotate the canvas context by 45 degrees (converted to radians)
        var angleInRadians = (configurations.rotation * Math.PI) / 180;
        //rotate
        ctx.rotate(angleInRadians);

        //translate origin back to bottom left
        ctx.translate(
          -(originX + image.width * 0.5),
          -(originY + image.height * 0.5),
        );

        //Set the desired blend mode
        ctx.globalCompositeOperation = configurations.on_top
          ? "source-over"
          : "destination-out";

        //draw image
        ctx.drawImage(image, originX, originY);

        //Reset to default (good practice)
        ctx.globalCompositeOperation = "source-over";

        //move canvas origin to top left
        ctx.translate(0, -canvas.height);

        //Restore the canvas to its original state
        ctx.restore();

        //return canvas
        resolve(canvas);
      };

      // Optional: Handle errors during image loading
      image.onerror = (err) => {
        console.error("Error loading image:", err);
        //return canvas
        resolve(canvas);
      };
    } else {
      //return
      resolve(canvas);
    }
  });
}

//load file as image object
export async function loadImageFromFile(imageFile) {
  //load image
  return new Promise((resolve, reject) => {
    //create new image object
    const imageObj = new Image(); // Create a new Image object

    // Set crossOrigin to "Anonymous" if loading images from different domains
    // to avoid potential CORS issues that restrict canvas data access.
    imageObj.crossOrigin = "Anonymous";
    imageObj.src = URL.createObjectURL(imageFile);

    //on load image
    imageObj.onload = async () => {
      //return image
      resolve(imageObj);
    };

    // Optional: Handle errors during image loading
    imageObj.onerror = (err) => {
      console.error("Error loading image:", err);
      //return
      resolve(null);
    };
  });
}

//base64 string to image file
export async function base64ToBlob(data, mime) {
  //try - cathc
  try {
    // Decode the Base64 string into binary data
    const bstr = atob(data);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    // Populate the Uint8Array with the binary data
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    // Create and return a Blob object
    return new Blob([u8arr], { type: mime });
  } catch (e) {
    //retun
    return null;
  }
}

//file name without extension
//ex: xx.jpg return xx
export const getFileNameWithoutExtension = (filename) => {
  const parts = filename.split(".");
  // If there's no extension (or it's a dotfile like ".config"), handle that case
  if (parts.length === 1 || (parts[0] === "" && parts.length === 2)) {
    return filename;
  }
  // Remove the last element (the extension)
  parts.pop();
  // Re-join the remaining parts
  return parts.join(".");
};

//download file from url
export const downloadFromURL = async (fileUrl, fileName) => {
  try {
    // Fetch the file data
    const response = await fetch(fileUrl);
    // Convert the response to a Blob (Binary Large Object)
    const blob = await response.blob();
    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "downloaded-file"; // Set the desired file name

    // Append the link to the document body, click it, and remove it
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);

    // Clean up the blob URL
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error fetching the file:", error);
    // Handle CORS issues or other fetch errors here
  }
};

//download file from url
export const loadFromURLAsBlob = async (fileUrl) => {
  try {
    // Fetch the file data
    const response = await fetch(fileUrl);
    // Convert the response to a Blob (Binary Large Object)
    const blob = await response.blob();
    //return
    return blob;
  } catch (error) {
    console.error("Error fetching the file:", error);
    // Handle CORS issues or other fetch errors here
    return null;
  }
};
